import axios from 'axios'
import { pcBaseURL } from '@/config.js'
import { getStorage,removeStorage } from '../utils/auth.js'
// import { wxAuthorize } from "../utils/utils";
const instance = axios.create({
    baseURL: pcBaseURL,
    timeout: 100000,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
});
instance.interceptors.request.use(function (config) {
    const info = JSON.parse(getStorage('info'))
    if( info ){
      config.headers.token = info.token
      config.headers['Authorization'] = 'Bearer ' + info.token
    }
    return config;
});
instance.interceptors.response.use(function (response) {
    const statuCode = [501,502,503,504,505]
    console.log("pc response.data.code ==", response.data.code, response.data.code == 401);

    if(response.status !== 200){
        return Promise.reject(response.data)
    }else if(statuCode.includes(response.data.code)){
        // removeStorage("info")
        // window.location.href = wxAuthorize(window.location.href)
    }else if(response.data.code == 506 || response.data.code == 401){
        console.log("pc response.data.code ==", response.data.code);
        removeStorage("info")
        window.location.reload()
    } else {
        return response.data;
    }
});

export default instance